import { render, staticRenderFns } from "./PDFTranslateVisor.vue?vue&type=template&id=3e6f4776&scoped=true&"
import script from "./PDFTranslateVisor.vue?vue&type=script&lang=js&"
export * from "./PDFTranslateVisor.vue?vue&type=script&lang=js&"
import style0 from "./PDFTranslateVisor.vue?vue&type=style&index=0&id=3e6f4776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6f4776",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VIcon,VLayout})
